const component = "site-section-appliances-count-by-programming-category";

export const siteSectionAppliancesCountByProgrammingCategory = {
  component,
  categoryItem: `${component}/category-item`,
  icon: `${component}/icon`,
  categoryText: `${component}/category-text`,
} as const;
